export const formatPhoneNumber = (value) => {
    if (value) {
        value = value.replace(/\D/g, '');

        if (value.startsWith('1') && value.length > 10) { value = value.substr(1); }

        const matches = value.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (value && matches) {
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
        }
    }
};

export const modifyToInstance = (value, isPascalCase = true) => {
    if (value && value.toLowerCase().includes('franchise')) {
        value = isPascalCase
            ? value.replace('Franchise', 'Instance')
            : value.replace('franchise', 'instance');

    }

    return value;
}

export const numberFormat = (value) => {
    if (value) {
        value = value.toString();
        const p = value.replace(/,/g, '').split('.');
        value = p[0]
            .split('')
            .reverse()
            .reduce((acc, price, i) => {
                return price === '-' ? `${price}${acc}` : price + (i && !(i % 3) ? ',' : '') + acc;
            }, '');

        if (p[1] || p[1] === '') {
            value = `${value}`.concat(`.${p[1]}`);
        }

        if (value.indexOf('.') >= 0) {
            value = value.substr(0, value.indexOf('.')) + value.substr(value.indexOf('.'), 3);
        }
    } else {
        return '';
    }

    return `${value}`;
};
